import React from 'react';
import { get } from 'lodash';

import UnsubscribeHTTPService from '../api/UnsubscribeHTTPService';
import PublicPositionHttpService from '../api/PublicPositionHttpService';

const UnsubscribeContext = React.createContext({});

export const UnsubscribeProvider = UnsubscribeContext.Provider;
export const UnsubscribeConsumer = UnsubscribeContext.Consumer;

const unsubscribeTalent = (unsubscribeData) => UnsubscribeHTTPService.unsubscribe(unsubscribeData);

const getUnsubscribeDataByUuid = async (positionApprovalUuid) => {
    const {
        talentId,
        positionId,
        positionData,
        candidateData,
    } = await PublicPositionHttpService.getPublicPositionApproval(positionApprovalUuid);
    const { employerId } = positionData;
    const talentEmail = get(candidateData, 'email', '');
    return {
        talentId,
        positionId,
        employerId,
        talentEmail,
    };
};

export const UnsubscribeApp = ({ children }) => (
    <UnsubscribeProvider value={{
        unsubscribeTalent,
        getUnsubscribeDataByUuid,
    }}>
        {children}
    </UnsubscribeProvider>
);

export default UnsubscribeContext;
